export default __webpack_public_path__ + "static/media/banner-bg-ir-2025.e2c0691d.jpg";